import { forwardRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { AtSign, TrendingUp, TrendingDown, Minus } from 'lucide-react'
import { SectionCard } from '../../patterns/SectionCard'
import { Avatar } from '../../patterns/Avatar'
import { ago } from './ReachingYouCard'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const MentionsCard = forwardRef<HTMLDivElement, { items: any[] | null; digest: any | null }>(function MentionsCard({ items, digest }, ref) {
  const navigate = useNavigate()
  const ToneIcon = digest?.tone === 'up' ? TrendingUp : digest?.tone === 'down' ? TrendingDown : Minus
  const toneCls = digest?.tone === 'up' ? 'text-emerald-400' : digest?.tone === 'down' ? 'text-rose-400' : 'text-muted-foreground'
  return (
    <div ref={ref}>
      <SectionCard icon={<AtSign size={14} />} title="Mentions of you" fill noBodyPadding>
        {(!items || items.length === 0) ? (
          <div className="px-5 py-6 text-center text-xs text-muted-foreground/70">No mentions in the last 14 days.</div>
        ) : (
          <div className="divide-y divide-border/60">
            {items.map((m) => (
              <button key={m.id} type="button" onClick={() => navigate(m.link)} className="w-full text-left px-5 py-3 flex items-start gap-3 hover:bg-accent/40 transition">
                <Avatar name={m.author?.name} src={m.author?.avatarUrl} className="h-7 w-7 text-xs shrink-0 mt-0.5" />
                <span className="flex-1 min-w-0">
                  <span className="flex items-center gap-2 text-xs text-muted-foreground">
                    <span className="font-medium text-foreground text-sm truncate">{m.author?.name}</span>
                    <span className="truncate">{m.sourceName}</span>
                    <span className="ml-auto shrink-0 tabular-nums">{ago(m.at)}</span>
                  </span>
                  <span className={`block text-xs truncate ${m.unread ? 'text-foreground' : 'text-muted-foreground'}`}>{m.snippet}</span>
                </span>
                {m.unread && <span className="shrink-0 w-2 h-2 rounded-full bg-primary mt-2" />}
              </button>
            ))}
          </div>
        )}
        {digest && (
          <div className="px-5 py-2.5 border-t border-border/60 flex items-center gap-2 text-[11px] text-muted-foreground">
            <ToneIcon size={12} className={toneCls} />
            You came up in <span className="tabular-nums font-medium text-foreground">{digest.count7d}</span> conversations this week
          </div>
        )}
      </SectionCard>
    </div>
  )
})
export default MentionsCard
